export enum SafetyRiskAlertStatus {
  CREATED = 'CREATED',
  VIEWED = 'VIEWED',
  ACKNOWLEDGED = 'ACKNOWLEDGED',
}

export enum SafetyRiskAlertTriggerReasonCode {
  PHQ9_Q9_WITH_NONZERO_DONE = 'PHQ9_Q9_WITH_NONZERO_DONE',
  PHQ9_Q9_WITH_NONZERO_IN_PROGRESS = 'PHQ9_Q9_WITH_NONZERO_IN_PROGRESS',
  PHQ9_Q1_THRU_8_ANSWERED_WITH_NULL_Q9 = 'PHQ9_Q1_THRU_8_ANSWERED_WITH_NULL_Q9',
}

export type SafetyRiskAlert = {
  safetyRiskAlertId: string;
  surveyResponseExternalId: string;
  providerId: string;
  triggerReasonCode: string;
  patientId: string;
  patientName?: string;
  completedByUserId?: string;
  createdAt?: string;
  statusCode?: string;
};

type GetSafetyRiskAlertsRawAlert = {
  id: string;
  surveyResponseExternalId: string;
  providerId: string;
  patientId: string;
  statusCode: string;
  triggerReasonCode: string;
  createdAt: string;
  updatedAt: string;
};

export type GetSafetyRiskAlertsResponse = {
  alerts: GetSafetyRiskAlertsRawAlert[];
};

export const normalizeGetAlert = (
  raw: GetSafetyRiskAlertsRawAlert,
): SafetyRiskAlert => ({
  safetyRiskAlertId: raw.id,
  surveyResponseExternalId: raw.surveyResponseExternalId,
  providerId: raw.providerId,
  patientId: raw.patientId,
  triggerReasonCode: raw.triggerReasonCode,
  createdAt: raw.createdAt,
  statusCode: raw.statusCode,
});
